<template>
  <div class="wrap-container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Container",
};
</script>

<style scoped>
div.wrap-container {
  text-align: left;
  padding: 0;
  box-sizing: border-box;
  vertical-align: top;
}
</style>
